function assert(condition) {
  if (condition) return;
  throw new Error("You stumbled upon a vike-vue bug, reach out on GitHub.");
}
function assertWarning(condition, message) {
  console.warn(new Error(message));
}
export {
  assertWarning as a,
  assert as b
};
//# sourceMappingURL=assert-CI16lhfz.js.map
